module.exports = __webpack_public_path__ + "static/media/dropdown_submenu.87a3a20b.svg";